import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import whiteSop from "../assets/media/white-logo.png";
import globeSoccer from "../assets/media/globe-soccer-transparent.png";
import HeaderFeedback from "../components/header-feedback";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const ARABIC_DIGITS = {
  1: "١",
  2: "٢",
  3: "٣",
  4: "٤",
  5: "٥",
};

// const temp1 = [
//   {
//     "id": 1,
//     "text": "خدمات المسؤول عن التواصل معك لتاكيد الحضور والحصول على المستنادات المطلوبة؟"
//   },
//   {
//     "id": 2,
//     "text": "استقبالك في المطار عند الوصول ومرافقتكم الى المواقف؟"
//   },
//   {
//     "id": 3,
//     "text": "خدمة النقل من المطار الى الفندق وحالة المركبة الموفرة لهذه الخدمة؟"
//   },
//   {
//     "id": 4,
//     "text": "الاستقبال في الفندق وتسجيل الوصول؟"
//   },
//   {
//     "id": 5,
//     "text": "خدمة النقل من الفندق الى الحفل؟"
//   },
//   {
//     "id": 6,
//     "text": "هل استمتعت بحضور الحفل   Globe Soccer Awards؟"
//   },
//   {
//     "id": 7,
//     "text": "هل كانت المعلومات المقدمة لاجندة الحفل وافية؟"
//   },
//   {
//     "id": 8,
//     "text": "كيف تقيم رحلتك بشكل عام؟"
//   }
// ]
// const temp2 = [
//   {
//     "id": 1,
//     "text": "1"
//   },
//   {
//     "id": 2,
//     "text": "2"
//   },
//   {
//     "id": 3,
//     "text": "3"
//   },
//   {
//     "id": 4,
//     "text": "4"
//   },
//   {
//     "id": 5,
//     "text": "5"
//   }
// ]

const fetchQuestions = async () => {
  const res = await fetch(`${API_BASE}/api/questions`);
  const json = await res.json();
  return json.data;
};

const fetchOptions = async () => {
  const res = await fetch(`${API_BASE}/api/options`);
  const json = await res.json();
  return json.data;
};

const submitFeedback = async (payload) => {
  const res = await fetch(`${API_BASE}/api/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json.message || "Submit failed");
  return json;
};

const Feedback = () => {
  const [ratings, setRatings] = useState({});
  const [apiMessage, setApiMessage] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("feedback_submitted")) {
      setAlreadySubmitted(true);
    }
  }, []);

  const { data: questions = [], isLoading: questionsLoading, error: questionsError } = useQuery({
    queryKey: ["questions"],
    queryFn: fetchQuestions,
  });

  const { data: options = [], isLoading: optionsLoading } = useQuery({
    queryKey: ["options"],
    queryFn: fetchOptions,
  });

  const { mutate, isPending: submitting } = useMutation({
    mutationFn: submitFeedback,

    onSuccess: (response) => {
      setApiError(null);
      setApiMessage(response.message);

      // Save submission to browser
      localStorage.setItem("feedback_submitted", "true");
      setAlreadySubmitted(true);
    },

    onError: (error) => {
      setApiMessage(null);
      setApiError(error.message);
    },
  });

  const setRating = (questionId, value) => {
    setRatings((prev) => ({ ...prev, [questionId]: value }));
  };

  const handleSubmit = () => {
    const unanswered = questions.find((q) => !ratings[q.id]);
    if (unanswered) {
      setApiMessage(null);
      setApiError("يرجى الإجابة على جميع الأسئلة قبل الإرسال.");
      return;
    }

    const payload = {
      answers: questions.map((q) => ({
        question: q.id,
        answer: ratings[q.id],
      })),
    };

    mutate(payload);
  };

  if (questionsLoading || optionsLoading) {
    return <div className="heading" dir="rtl">جاري تحميل الاستبيان...</div>;
  }

  if (questionsError) {
    return <div className="heading" dir="rtl">فشل تحميل الأسئلة</div>;
  }

  if (alreadySubmitted) {
    return (
      <>
        <div className="landing-bg">
          <HeaderFeedback />
          <p className="sub-heading-2" dir="rtl" style={{ textAlign: "center" }}>رأيك يهمنا</p>

          <div
            className="form-wrapper"
            dir="rtl"
            style={{ paddingTop: 80, textAlign: "center" }}
          >
            <div
              style={{
                color: "#fff",
                fontWeight: 700,
                fontSize: 20,
                marginBottom: 20,
              }}
            >
              لقد أرسلتَ التقييم بالفعل. شكرًا لك!
            </div>
          </div>
        </div>

        <div className="footer-feedback">
          <img src={whiteSop} alt="logo" width={80} />
          <img src={globeSoccer} alt="logo" width={100} />
        </div>
      </>
    );
  }

  return (

    <>
      <div className="landing-bg">
        <HeaderFeedback />

        <p className="sub-heading-2" dir="rtl" style={{ textAlign: "center" }}>رأيك يهمنا</p>
        <p className="sub-heading" dir="rtl">نرجو من حضرتكم التكرم بمشاركتنا بتقييمكم من خلال الاجابة على الاسئلة المرفقة في الاستبيان التالي واختياركم الارقام من ١ الى ٥
        </p>
        <p className="sub-heading" style={{ marginTop: "0" }} dir="rtl">(علما انا ١ غير راضي و ٥ راضي جدا)</p>

        <div className="form-wrapper" dir="rtl">
          {questions.map((q) => (
            <div key={q.id} style={{ padding: 14, borderBottom: "1px solid #eee" }}>
              <div className="questions">{q.text}</div>
              <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                <div style={{ display: "inline-flex", gap: 15 }}>
                  {options.map((opt) => {
                    const selected = ratings[q.id] === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className="ratings"
                        onClick={() => setRating(q.id, opt.id)}
                        style={{
                          background: selected ? "#83BC00" : "transparent",
                          border: selected ? "2px solid #83BC00" : "1px solid #ddd",
                          color: "#fff",
                        }}
                      >
                        <span className="rating-text">{ARABIC_DIGITS[opt.id]}</span>
                      </button>
                    );
                  })}
                </div>

                <div className="rating-scale">
                  <span>غير راضٍ</span>
                  <span>راضٍ جدًا</span>
                </div>
              </div>
            </div>
          ))}

          {apiMessage && (
            <div style={{ color: "#059669", fontWeight: "700", marginBottom: 15 }}>
              {apiMessage}
            </div>
          )}

          {apiError && (
            <div style={{ color: "#b91c1c", fontWeight: "700", marginBottom: 15 }}>
              {apiError}
            </div>
          )}

          <div className="btn-wrapper">
            <button
              className="submit-btn"
              type="button"
              onClick={handleSubmit}
              disabled={submitting}
              style={{
                background: submitting ? "#405a02ff" : "#83BC00",
                border: "none",
              }}
            >
              {submitting ? "جاري الإرسال..." : "إرسال التقييم"}
            </button>
          </div>
        </div>
      </div>

      <div className="footer-feedback-main">
        <img src={whiteSop} alt="logo" width={80} />
        <img src={globeSoccer} alt="logo" width={100} />
      </div>

    </>
  );
};

export default Feedback;
